"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBoxMultiple = void 0;
const react_1 = __importDefault(require("react"));
const valueForm_1 = require("../../../hooks/valueForm");
const stable_1 = require("../stable");
require("./index.scss");
const className = 'checkbox-multiple';
const CheckBoxMultiple = (props) => {
    const { title, items, toItem, value = [], setValue, hidden } = props;
    if (hidden)
        return null;
    return (react_1.default.createElement("div", { className: className },
        title && (react_1.default.createElement("div", { className: `${className}__title` }, title)), items === null || items === void 0 ? void 0 :
        items.map(toItem).map((item) => {
            return (react_1.default.createElement(stable_1.CheckBoxStable, { key: item.value, textRight: item.label, modificators: ['inline-zero', item.modificators], nativeValue: value.some(x => x === item.value), onChange: (event) => {
                    const checked = (0, valueForm_1.parseNativeEvent)(event, 'boolean');
                    const newValue = value.filter(x => x !== item.value);
                    if (checked) {
                        newValue.push(item.value);
                    }
                    setValue(newValue);
                } }));
        })));
};
exports.CheckBoxMultiple = CheckBoxMultiple;
//# sourceMappingURL=index.js.map